<template>
  <div class="dashboard">
    <div class="welcome-card">
      <h2>Welcome to Omni Hub</h2>
      <p>Your central operations dashboard for omni-craft ecosystem monitoring.</p>
      <p class="deployment-test">🚀 Multi-package deployment test - both CDN and Hub pipelines active!</p>
    </div>

    <div class="grid">
      <div class="card">
        <h3>🎭 E2E Test Results</h3>
        <p>Playwright test results and reports from staging and production deployments.</p>
        <div class="status pending">Coming Soon</div>
      </div>

      <div class="card">
        <h3>🚀 Deployment Status</h3>
        <p>Real-time GitHub Actions workflow status and deployment history.</p>
        <div class="status pending">Coming Soon</div>
      </div>

      <div class="card">
        <h3>📊 Performance Metrics</h3>
        <p>CDN performance, page load times, and Cloudflare analytics.</p>
        <div class="status pending">Coming Soon</div>
      </div>

      <div class="card">
        <h3>🔧 Infrastructure Health</h3>
        <p>System status, error tracking, and resource monitoring.</p>
        <div class="status pending">Coming Soon</div>
      </div>
    </div>

    <div class="info-card">
      <h3>🏗️ Under Construction</h3>
      <p>This operations hub is being built to provide comprehensive monitoring and insights for the omni-craft ecosystem. Future features will include:</p>
      <ul>
        <li>Interactive test result visualization</li>
        <li>Deployment pipeline monitoring</li>
        <li>Performance trend analysis</li>
        <li>Real-time error tracking</li>
        <li>Infrastructure health dashboards</li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
// Dashboard component logic will be added here
</script>

<style scoped>
.dashboard {
  max-width: 1200px;
  margin: 0 auto;
}

.welcome-card {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.welcome-card h2 {
  margin: 0 0 1rem 0;
  color: #333;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.card {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
}

.card:hover {
  transform: translateY(-2px);
}

.card h3 {
  margin: 0 0 1rem 0;
  color: #333;
}

.card p {
  color: #666;
  margin-bottom: 1rem;
}

.status {
  display: inline-block;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 500;
}

.status.pending {
  background: #fff3cd;
  color: #856404;
  border: 1px solid #ffeaa7;
}

.info-card {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 2rem;
  border-left: 4px solid #667eea;
}

.info-card h3 {
  margin: 0 0 1rem 0;
  color: #333;
}

.info-card ul {
  margin: 1rem 0 0 0;
  padding-left: 1.5rem;
}

.info-card li {
  margin-bottom: 0.5rem;
  color: #666;
}

.deployment-test {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 1rem;
  border-radius: 8px;
  margin: 1rem 0;
  font-weight: 500;
  text-align: center;
}
</style>